module.exports = __webpack_public_path__ + "img/earth_elemental_small.800e6797.png";